module.exports = __webpack_public_path__ + "img/fifth_cloud_bottom_color.a31471a3.png";